export default __webpack_public_path__ + "static/media/collection_setting.41868766.jpg";